import PropTypes from 'prop-types';
import React from 'react';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import ScheduleCall from 'src/svgs/tool/schedule-call.svg';
import {header} from '../header.module.scss';
import {icon} from './style.module.scss';

export const ConfirmCancelledView = ({
  appointment,
  onCancel,
  onConfirmCancel,
}) => {
  return (
    <div>
      <header className={header}>
        <ScheduleCall className={icon} />
        {
          appointment.timeValid
          && <h1>Would you like to cancel your call for {appointment.time}?</h1>
        }
        {
          !appointment.timeValid
          && <h1>Would you like to cancel your call?</h1>
        }
      </header>
      <div className={buttonGroup}>
        <button className={`${button} ${primary}`} onClick={onConfirmCancel}>Yes, Cancel</button>
        <button className={button} onClick={onCancel}>No Thanks</button>
      </div>
    </div>
  );
};

ConfirmCancelledView.propTypes = {
  appointment: PropTypes.shape({
    time: PropTypes.string,
    timeValid: PropTypes.bool,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirmCancel: PropTypes.func.isRequired,
};
